import React from 'react';
import PropTypes from 'prop-types';

import Strings from '../Strings';
import { DATE_TIME_SPACE_12_UPPERCASE } from '../constants';
import { formatReadingReceipt, getReadingReceipt } from '../utils/readingReceipt';

import './ReceivedAtDate.scss';

export default function ReceivedAtDate({
  measuredAt,
  backendTimestamp,
  displayReference = measuredAt,
  displayFormat = DATE_TIME_SPACE_12_UPPERCASE,
  children,
}) {
  const receipt = getReadingReceipt(measuredAt, backendTimestamp);
  if (!receipt) return children;
  const received = Strings.formatString(Strings.readingReceipt.receivedAt, formatReadingReceipt(receipt.receivedAt, displayReference, displayFormat));
  const tooltip = receipt.delayed ? `${Strings.readingReceipt.delayed} ${received}` : received;
  return (
    <span
      className="icon-and-text-container reading-received-at"
      data-testid="reading-received-at"
      data-tooltip-id="tooltip"
      data-tooltip-content={tooltip}
      tabIndex={0}
    >
      {children}
      {receipt.delayed && (
        <span className="icon-container warning no-margin" role="img" aria-label={Strings.readingReceipt.delayed} />
      )}
    </span>
  );
}

ReceivedAtDate.propTypes = {
  measuredAt: PropTypes.any,
  backendTimestamp: PropTypes.string,
  displayReference: PropTypes.any,
  displayFormat: PropTypes.string,
  children: PropTypes.node,
};
